export const featuredPortfolio = [
    {
      id: 1,
      title: "Social Media App",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 2,
      title: "Rampa UI Design",
      img:
        "https://cdn.dribbble.com/users/702789/screenshots/15054318/media/4ea5d492b7b07eebc9528ff960794879.png?compress=1&resize=1200x900",
    },
    {
      id: 3,
      title: "E-commerce Web Design",
      img:
        "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
    },
    {
      id: 4,
      title: "Relax Mobile App",
      img:
        "https://cdn.dribbble.com/users/4095861/screenshots/15467417/media/d6a15c416626f12b31fa5ca1db192572.png?compress=1&resize=1200x900",
    },
    {
      id: 5,
      title: "Hero Web Design",
      img:
        "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
    },
    {
      id: 6,
      title: "Banking App",
      img:
        "https://cdn.dribbble.com/users/3307260/screenshots/15468444/media/447b4501f7a145b05e11c70199a9c417.jpg?compress=1&resize=1200x900",
    },
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Portfolio Using HTML & CSS",
      img: "assets/web1.png",
      link:"https://avijitchowdhury.github.io/web-portfolio/",
      code:"https://github.com/AvijitChowdhury/web-portfolio"
    },
    {
      id: 2,
      title: "E-commerce site using bootstrap",
      link:"https://avijitchowdhury.github.io/E-Commerce-Website/",
      code:'https://github.com/AvijitChowdhury/E-Commerce-Website',
      img: "assets/web2.png",
    },
    {
      id: 3,
      title: "Client Portfolio Using html,css & bootsrap",
      link:"https://avijitchowdhury.github.io/Client-portfolio-project/",
      code:"https://github.com/AvijitChowdhury/Client-portfolio-project",
      img: "assets/web3.png",
    },
    {
      id: 4,
      title: "Digital gadgets using html,css & bootsrap",
      link:"https://avijitchowdhury.github.io/Digital-Gadgets-Website/",
      code:"https://github.com/AvijitChowdhury/Digital-Gadgets-Website",
      img: "assets/web4.png",
    },
    {
      id: 5,
      title: "Online Course Website using html,css & bootsrap",
      link:"https://avijitchowdhury.github.io/E-Course-Website/",
      code:"https://github.com/AvijitChowdhury/E-Course-Website",
      img: "assets/web5.png",
    },
    {
      id: 6,
      title: "Shopping Cart using html,css,bootsrap,javascript",
      link:"https://avijitchowdhury.github.io/Shopping-Cart-Website/",
      code:"https://github.com/AvijitChowdhury/Shopping-Cart-Website",
      img: "assets/web6.png",
    },
    {
      id: 7,
      title: "Calculator html,css,bootsrap,javascript",
      link:"https://avijitchowdhury.github.io/Calculator_project/",
      code:"https://github.com/AvijitChowdhury/Calculator_project",
      img: "assets/web6.png",
    },
    {
      id: 8,
      title: "Airplane animation css",
      link:"https://avijitchowdhury.github.io/Airplane_Animation/",
      code:"https://github.com/AvijitChowdhury/Airplane_Animation",
      img: "assets/web8.png",
    },
    {
      id: 9,
      title: "Pioneer Bank",
      link:"https://avijitchowdhury.github.io/Pioneer-Bank/",
      code:"https://github.com/AvijitChowdhury/Pioneer-Bank",
      img: "assets/web9.png",
    },
    {
      id: 10,
      title: "Weather API",
      link:"https://avijitchowdhury.github.io/Weather-API/",
      code:"https://github.com/AvijitChowdhury/Weather-API",
      img: "assets/web10.png",
    },
    
    {
      id: 11,
      title: "ema-jhon-website(mern stack app)",
      link:"https://ema-jhon-simple-2c1be.web.app/",
      code:"https://github.com/AvijitChowdhury/ema-jhon-website",
      img: "assets/web11.png",
    },
    {
      id: 12,
      title: "burj al arab(mern stack app)",
      link:"https://burj-al-arab-5e654.web.app/",
      code:"https://github.com/AvijitChowdhury/Burj-Al-Arab-Complete",
      img: "assets/web12.png",
    },
    {
      id: 13,
      title: "Pin Generator",
      link:"https://avijitchowdhury.github.io/Pin-Matcher-Project/",
      code:"https://github.com/AvijitChowdhury/Pin-Matcher-Project",
      img: "assets/web13.png",
    },

  ];
  
  export const mobilePortfolio = [
    {
      id: 1,
      title: "Food App (react-native)",
      link:"https://expo.dev/@avijit_chy/Restaurant_Project",
      code:"https://github.com/AvijitChowdhury/RestaurentProject",
      img:
        "assets/mbl1.png",
    },
    {
      id: 2,
      title: "tesla clone(react-native)",
      link:"https://github.com/AvijitChowdhury/TeslaClone",
      code:"https://github.com/AvijitChowdhury/TeslaClone",
      img:
        "assets/mbl2.png",
    },
    {
      id: 3,
      title: "Image touching app",
      link:"https://github.com/AvijitChowdhury/ImageTouchingApp",
      code:"https://github.com/AvijitChowdhury/ImageTouchingApp",
      img:
        "assets/mbl3.png",
    },
    {
      id: 4,
      title: "Chat App",
      link:"https://github.com/AvijitChowdhury/Chat-App",
      code:"https://github.com/AvijitChowdhury/Chat-App",
      img:
        "assets/mbl4.png",
    },
    {
      id: 5,
      title: "Video calling App",
      link:"https://github.com/AvijitChowdhury/ViChat",
      code:"https://github.com/AvijitChowdhury/ViChat",
      img:
        "assets/mbl5.png",
    },
    {
      id: 6,
      title: "Photo Edit",
      link:"https://github.com/AvijitChowdhury/VEdit-App",
      code:"https://github.com/AvijitChowdhury/VEdit-App",
      img:
        "assets/mbl6.png",
    },
    {
      id: 7,
      title: "QR scanner",
      link:"https://github.com/AvijitChowdhury/QR-Code_Scanner",
      code:"https://github.com/AvijitChowdhury/QR-Code_Scanner",
      img:
        "assets/mbl7.png",
    },
    {
      id: 8,
      title: "Browser App",
      link:"https://github.com/AvijitChowdhury/Browserapp",
      code:"https://github.com/AvijitChowdhury/Browserapp",
      img:
        "assets/mbl8.png",
    },
    {
      id: 9,
      title: "tic-tac-toe-game",
      link:"https://github.com/AvijitChowdhury/Tic-Tac-Toe-Game-App",
      code:"https://github.com/AvijitChowdhury/Tic-Tac-Toe-Game-App",
      img:
        "assets/mbl9.png",
    },
    {
      id: 10,
      title: "Calculator App",
      link:"https://github.com/AvijitChowdhury/Calculator-App",
      code:"https://github.com/AvijitChowdhury/Calculator-App",
      img:
        "assets/mbl10.png",
    },
    {
      id: 11,
      title: "Camera App",
      link:"https://github.com/AvijitChowdhury/CameraApp",
      code:"https://github.com/AvijitChowdhury/CameraApp",
      img:
        "assets/mbl11.png",
    },
    {
      id: 12,
      title: "Scientific App",
      link:"https://github.com/AvijitChowdhury/Scientific-Calculator",
      code:"https://github.com/AvijitChowdhury/Scientific-Calculator",
      img:
        "assets/mbl12.png",
    },
    {
      id: 13,
      title: "Flashlight",
      link:"https://github.com/AvijitChowdhury/Flashlight-App",
      code:"https://github.com/AvijitChowdhury/Flashlight-App",
      img:
        "assets/mbl13.png",
    },
    {
      id: 14,
      title: "QR Code Scanner",
      link:"https://github.com/AvijitChowdhury/QR-Code_Scanner",
      code:"https://github.com/AvijitChowdhury/QR-Code_Scanner",
      img:
        "assets/mbl14.png",
    },
    {
      id: 15,
      title: "Gallery App",
      link:"https://github.com/AvijitChowdhury/Gallery_App",
      code:"https://github.com/AvijitChowdhury/Gallery_App",
      img:
        "assets/mbl15.png",
    },
    {
      id: 16,
      title: "Musix",
      link:"https://github.com/AvijitChowdhury/VMUSIC",
      code:"https://github.com/AvijitChowdhury/VMUSIC",
      img:
        "assets/mbl16.png",
    },
   
    
    
  ];
  
  export const designPortfolio = [
    {
      id: 1,
      title: "Flyer",
      img:
        "assets/design1.png",
    },
    {
      id: 2,
      title: "Flyer",
      img:
        "assets/design2.png",
    },
    {
      id: 3,
      title: "Flyer",
      img:
        "assets/design3.png",
    },
    {
      id: 4,
      title: "Flyer",
      img:
        "assets/design4.png",
    },
    {
      id: 5,
      title: "Flyer",
      img:
        "assets/design5.png",
    },
    {
      id: 6,
      title: "flyer",
      img:
        "assets/design6.png",
    },
    {
      id: 7,
      title: "flyer",
      img:
        "assets/design7.png",
    },
    {
      id: 8,
      title: "flyer",
      img:
        "assets/design8.png",
    },
    {
      id: 9,
      title: "flyer",
      img:
        "assets/design9.png",
    },
    {
      id: 10,
      title: "flyer",
      img:
        "assets/design10.png",
    },
    {
      id: 11,
      title: "flyer",
      img:
        "assets/design11.png",
    },
   
  ];
  
  export const Machinelearning = [
    {
      id: 1,
      title: "House Price Prediction",
      link:"https://github.com/AvijitChowdhury/House_Price_Prediction",
      code:"https://github.com/AvijitChowdhury/House_Price_Prediction",
      img:
        "assets/ml1.png",
    },
    {
      id: 2,
      title: "Movie Recommender",
      link:"https://movierecomenderapp.herokuapp.com/",
      code:"https://github.com/AvijitChowdhury/MovieRecomenderApp",
      img:
        "assets/ml2.png",
    },
    {
      id: 3,
      title: "Email-Sms Spam Detector",
      link:"https://smsemailspamdetector.herokuapp.com/",
      code:"https://github.com/AvijitChowdhury/Sms-Email-Spam-Detector-App",
      img:
        "assets/ml3.png",
    },
    {
      id: 4,
      title: "Disease Predictor",
      link:"https://multiplediseasepredictionml.herokuapp.com/",
      code:"https://github.com/AvijitChowdhury/Multiple_Disease_Prediction",
      img:
        "assets/ml4.png",
    },
    {
      id: 5,
      title: "Olympic Data Analyzer",
      link:"https://olympicsdataanalytics.herokuapp.com/",
      code:"https://github.com/AvijitChowdhury/Olympics-Data-Analytic-Project",
      img:
        "assets/ml5.png",
    },
    


 
  ];
  export const deeplearning=[
    {
      id: 1,
      title: "Chatbot",
      link:"#",
      code:"https://github.com/AvijitChowdhury/chatbot",
      img: "assets/dp1.png",
    },
    {
      id: 2,
      title: "Cat-Dog-Classifier",
      link:"#",
      code:"https://github.com/AvijitChowdhury/Cat-Dog_Image_Predictor",
      img: "assets/dp3.png",
    },
    {
      id: 3,
      title: "Sentiment Analysis",
      link:"#",
      code:"hhttps://github.com/AvijitChowdhury/SentimentAnalysisApp",
      img: "assets/dp2.png",
    },
    {
      id: 4,
      title: "Car Detector",
      link:"#",
      code:"https://github.com/AvijitChowdhury/CarDetectionProject",
      img: "assets/opencv.png",
    }
  ];
  export const chromeExtension=[
    {
      id: 8,
      title: "Chrome Extension",
      link:"#",
      code:"https://github.com/AvijitChowdhury/Chorome_Extension/tree/main/Joke_Extension",
      img: "assets/web7.png",
    },
  ];
  export const rosProgramming=[
    {
      id:1,
      title:"RosPackage",
      link:"#",
      code:"",
      img:"",
    }
  ]